import React, {  useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';

import { useNotification } from 'config/Notification';

import { fetchReportCompanies as fetchReportCompaniesService, updateRequestReport as updateRequestReportService} from 'services/modules/ecs/report';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import { 
    Autocomplete,
    Button,
    CircularProgress, 
    FormControl, 
    TextField 
} from '@mui/material';

const RequestNewScanECS = ({ toggleRequestNewScan }) => {  
    // State Variables  
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingBtn , setLoadingBtn] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [show, setShow] = useState(true);
    
    //Redux Selectors
    const reportCompaniesContainer=useSelector((state)=>state.report.reportCompanies);
 
    //Notification
    const { openNotification } = useNotification();

    // Dispatch
    const dispatch = useDispatch();

    // Method to fetch the reports of the company
    const fetchReportData = async () => {
        try {
            setLoading(true);
            const params = {  project:"_id,name,domain",  limit:"null"}
            await dispatch(fetchReportCompaniesService(params))
           
        } 
        catch (error) {
            openNotification("Error fetching report:", 'error');
        } 
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // This method handles the requesting new scan of reports
    const handleRequestReport = async () => {
        try {
            if (!selectedCompany) {
                setError('Company is required');
                return;
            }
            setLoadingBtn(true); 
            let payload = { domain: selectedCompany.domain };
            const requestReport = await updateRequestReportService({payload})
           
            if ((requestReport.status === 201) || (requestReport.status === 200)){
                openNotification("Report request sent successfully.", 'success');
                setShow(false);
            }    
        } 
        catch (error) {
            let errorMessage = ''
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }
            openNotification(errorMessage, 'error');
            setShow(false);
        } 
        finally {
            setLoadingBtn(false); 
        }
    };

    // Method closes the request new scan
    const closing = () => {
        setShow(false);
        toggleRequestNewScan();
    }

    return (
        <Modal show={show} onHide={closing} dialogClassName="modal-90w"  animation={false}>
            <Modal.Header className="space-between" closeButton>
                <Modal.Title className="report-modal">
                    <LibraryBooksIcon className="m-1" />
                    <h4 className="report-heading-1"> Generate a report for your website</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              
                    <>
                        <div>
                            <div className="report-modal-buttons">
                                <FormControl className='report-form'>
                                    <Autocomplete
                                        options={reportCompaniesContainer?.results || []}
                                        getOptionLabel={(company) => company.domain}
                                        value={selectedCompany}
                                        onChange={(event, newValue) => {
                                            setSelectedCompany(newValue);
                                            setError('');
                                        }}
                                        onBlur={() => {
                                            if (!selectedCompany) {
                                                setError('Company is required');
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Company"
                                                variant="outlined"
                                                error={Boolean(error)}
                                                helperText={error}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </div>
                            <div className="report-modal-buttons">
                               <Button variant="outlined" className="reqreport-btn" onClick={handleRequestReport} disabled={loading}>
                                    {loadingBtn ? (
                                        <CircularProgress size={24} color="inherit" /> 
                                    ) : (
                                        <>
                                            <LibraryBooksIcon className="m-1" /> Request report
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </>
                
            </Modal.Body>
        </Modal>
    )
}
export default RequestNewScanECS;
